import * as RoomActionType from './constants';

const defaultParams = {
  searchKey: '',
  skip: 1,
  take: 10,
  sort: { field: 'name', order: 'ascending' },
  status: 'all',
  totalRecord: 0,
  totalPage: 0
};

const ManageRoom = {
  items: [],
  params: defaultParams
};

const RoomProfile = {
  id: '',
  name: '',
  dimension: '',
  isActive: true,
  readOnly: false
};

const RoomState = {
  ManageRoom: ManageRoom,
  RoomProfile: RoomProfile,
  ErrorMsg: [],
  IsOpenFormAddEdit: false,
  Title: 'New location',
  IsCreate: true,
  dateTime: new Date(),
  homeownerRoomSelectList: []
};

export default function RoomStore(state = RoomState, action) {
  switch (action.type) {
    case RoomActionType.SEARCH_ROOM_SUCCESS:
      return processSearchSuccess(state, action);
    case RoomActionType.OPEN_FORM_CREATE_ROOM:
      return {
        ...state,
        RoomProfile: RoomProfile,
        Title: 'New location',
        ErrorMsg: [],
        IsCreate: true,
        IsOpenFormAddEdit: true,
        dateTime: new Date()
      };
    case RoomActionType.CLOSE_FORM_CREATE_ROOM:
      return {
        ...state,
        IsOpenFormAddEdit: false
      };
    case RoomActionType.CREATE_ROOM_ASYNC:
    case RoomActionType.UPDATE_ROOM_ASYNC:
    case RoomActionType.UPDATE_DEFAULT_CONFIGS_ASYNC:
      return {
        ...state,
        ErrorMsg: []
      };
    case RoomActionType.GET_ROOM_BY_ID_SUCCESS:
      return processGetRoomByIdSuccess(state, action);
    case RoomActionType.ADD_EDIT_ROOM_ERROR:
      return processAddEditRoomError(state, action);
    case RoomActionType.RESET_ROOM:
      return {
        ...state,
        ManageRoom: {
          ...state.ManageRoom,
          params: defaultParams
        }
      };
    case RoomActionType.FETCH_HOMEOWNER_ROOM_SELECT_LIST_SUCCESS:
      return {
        ...state,
        homeownerRoomSelectList: action.data
      };
    default:
      return state;
  }
}

const processSearchSuccess = (state, action) => {
  var result = action.data;
  var manageRoom = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip + 1,
      take: result.params.take,
      status: result.params.status,
      name: result.params.name,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };
  return {
    ...state,
    ManageRoom: manageRoom,
    ErrorMsg: [],
    IsOpenFormAddEdit: false
  };
};

const processGetRoomByIdSuccess = (state, action) => {
  return {
    ...state,
    RoomProfile: action.data,
    Title: 'Edit location',
    ErrorMsg: [],
    IsCreate: false,
    IsOpenFormAddEdit: true
  };
};

const processAddEditRoomError = (state, action) => {
  return {
    ...state,
    ErrorMsg: [action.data.error],
    RoomProfile: {
      ...state.RoomProfile,
      name: action.data.params.name
    }
  };
};



// WEBPACK FOOTER //
// ./src/Rooms/reducers.js